// Copyright © 2021 Move Closer
export * from './TextArea';
export * from './TextArea.contracts';
